import { render } from "./enterSharedinfo.vue?vue&type=template&id=51f770a1"
import script from "./enterSharedinfo.vue?vue&type=script&lang=js"
export * from "./enterSharedinfo.vue?vue&type=script&lang=js"

import "./enterSharedinfo.vue?vue&type=style&index=0&id=51f770a1&lang=less"

import exportComponent from "D:\\project\\Mase_Customer\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__